import {ValueDefinition} from '@/model/types';

export const enum WithdrawalTypeCIQ {
  TOTAL = 'DV-72#0',
  PARTIAL = 'DV-72#1',
}

export const DV_72 = {
  id: 'DV-72',
  description: {
    fr: 'Virement inter-comptes (bloc I) / Type de retrait (compte à intérêt quotidien) (bloc O)',
    en: 'Inter-account transfer (block I) / Withdrawal type (daily interest account) (block O)',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Total',
        en: 'Total',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Partiel',
        en: 'Partial',
      },
    },
  ],
} as const satisfies ValueDefinition;
